import React from 'react';
import { Router, browserHistory } from 'react-router'
import Firebase from 'firebase';



export default class filters extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            SelectElements: [],
            element: {},
            option: "",
            trigger: ""
        }
        this.renderTrigger = this.renderTrigger.bind(this);
        this.setOptions = this.setOptions.bind(this);
    }

    componentWillMount() {
        var array = [];
        var obj = {};
        Object.values(this.props.data).map((f) => {
            Object.values(f.elements).map((m, index) => {
                if (m.element_id == "DROPDOWNLIST") {
                    array.push({
                        value: m,
                        text: m.id
                    })
                }
            })
        });
        this.setState({ SelectElements: array });
        var datasetsRef = Firebase.database()
            .ref('datasets')
            .child(localStorage.client_id)
            .child("tablas").child(this.props.element.table.dataset);
        datasetsRef.once('value')
            .then(resp => {
                this.setState({ columnas: Object.values(resp.val())[0] })
            })
    }


    setOptions(trigger) {
        Object.values(this.props.data).map((f) => {
            Object.values(f.elements).map((m, index) => {
                if (m.id == trigger) {
                    var datasetsRef = Firebase.database()
                        .ref('datasets')
                        .child(localStorage.client_id)
                        .child("tablas").child(m.table.dataset);
                    datasetsRef.once('value')
                        .then(resp => {
                            this.setState({ opt_elem_1: Object.values(resp.val())[0] })
                        })
                }
            })
        });
    }


    renderTrigger() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="form-group row">
                        <div className="col-md-5">
                            {
                                this.state.columnas ?
                                    <div className="form-group row">
                                        <label htmlFor="name">Seleccione Columna:</label>
                                        <select className="form-control" id="ccmonth" onChange={(e) => { this.setState({ col_name: e.target.value }) }}>
                                            <option value="" defaultValue hidden>Seleccione una columna</option>
                                            {
                                                this.state.columnas.map((e) => (
                                                    <option value={e}>{e}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    :
                                    ""
                            }
                        </div>
                        <div className="col-md-5 offset-md-1">
                            <div className="form-group row">
                                <label htmlFor="name">Seleccione Opición:</label>
                                <select className="form-control" id="ccmonth" onChange={(e) => { this.setState({ option: e.target.value }) }}>
                                    <option value="" defaultValue hidden>Seleccione una columna</option>
                                    <option value="element">Elemento</option>
                                    <option value="value">Ingresar valor</option>
                                </select>
                            </div>
                            {
                                this.state.option === "element" ?
                                    <div className="form-group row">
                                        <div>
                                            <label htmlFor="name">Seleccione elemento:</label>
                                            {
                                                this.state.SelectElements ?
                                                    <select className="form-control" id="ccmonth" onChange={(e) => { this.setState({ trigger: e.target.value }); this.setOptions(e.target.value) }}>
                                                        <option value="" defaultValue hidden>Seleccione un Elemento</option>
                                                        {
                                                            this.state.SelectElements.map((e) => (
                                                                <option value={e.value.id}>{e.text}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    :
                                                    ""
                                            }
                                        </div>
                                        {
                                            this.state.opt_elem_1 ?
                                                <div>
                                                    <label htmlFor="name">valor:</label>
                                                    <select className="form-control" id="ccmonth" onChange={(e) => { this.setState({ value: e.target.value }); }}>
                                                        <option value="" defaultValue hidden>Seleccione un valor</option>
                                                        {
                                                            this.state.opt_elem_1.map((e) => (
                                                                <option value={e}>{e}</option>
                                                            ))
                                                        }
                                                    </select>
                                                </div>
                                                :
                                                ""
                                        }
                                    </div>
                                    :
                                    this.state.option === "value" ?
                                        <div className="form-group row">
                                            <label htmlFor="name">Valor:</label>
                                            <input type="text" className="form-control" id="name" value={this.state.value}
                                                placeholder="ingrese un valor"
                                                onChange={(e) => {
                                                    this.setState({ value: e.target.value, trigger: "value" });
                                                }} />
                                        </div>
                                        :
                                        ""
                            }
                        </div>
                    </div>
                </div>
            </div >
        );
    }

    render() {
        var obj = {};
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="card card-outline-success mb-3">
                        <div className="card-block">
                            <blockquote className="card-blockquote">
                                <div className="form-group row">
                                    <div className="col-md-10">
                                        {this.renderTrigger()}
                                    </div>
                                    <div className="col-md-2">
                                        {
                                            this.state.done !== true ?
                                                <button style={{ marginTop: "28px" }} onClick={() => { obj = { [this.state.col_name]: { [this.state.trigger]: this.state.value } }; this.props.callBack(obj, this.state.trigger); this.setState({ done: true }) }} type="button" className="btn btn-outline-primary">Añadir</button>
                                                : ""
                                        }
                                    </div>
                                </div>
                            </blockquote>
                        </div>
                    </div>
                </div>
            </div >
        );
    };
}


// WEBPACK FOOTER //
// ./src/views/functions/filters.js